module.exports = __webpack_public_path__ + "assets/img/Windows.a35a022f.svg";